import _ from 'lodash';
import React from 'react';
import booleanFilterMethod from '../filter-methods/booleanFilterMethod';
import NullableBooleanFilter from '../filter-components/NullableBooleanFilter';
import TextFilter from '../filter-components/TextFilter';
import textFilterMethod from '../filter-methods/textFilterMethod';
import DateFilter from '../filter-components/DateFilter';
import dateFilterMethod from '../filter-methods/dateFilterMethod';

function applyNullableBooleanFilter(column, data) {
  return {
    ...column,
    filterable: true,
    Filter: (props) => <NullableBooleanFilter {...props} data={data} />,
    filterMethod: booleanFilterMethod,
  };
}

function applyTextFilter(column, data) {
  return {
    ...column,
    filterable: true,
    Filter: (props) => <TextFilter {...props} data={data} />,
    filterMethod: textFilterMethod,
  };
}

function applyDateFilter(column, data) {
  return {
    ...column,
    filterable: true,
    Filter: (props) => <DateFilter {...props} data={data} />,
    filterMethod: dateFilterMethod,
    type: 'date',
  };
}

export default function fieldFilters(data) {
  return {
    applyNullableBooleanFilter: _.bind(applyNullableBooleanFilter, null, _, data),
    applyTextFilter: _.bind(applyTextFilter, null, _, data),
    applyDateFilter: _.bind(applyDateFilter, null, _, data),
  };
}
